import { proxy } from 'valtio';
export const sungopStockStore = proxy({
    stockType: 'tw50',
    menuSymbolMode: 'entrySignal',
    marketViewMode: 'AboveAvgLine',
});
